import { render, staticRenderFns } from "./PeopleView.vue?vue&type=template&id=0ee7f1a8&scoped=true&"
import script from "./PeopleView.vue?vue&type=script&lang=js&"
export * from "./PeopleView.vue?vue&type=script&lang=js&"
import style0 from "./PeopleView.vue?vue&type=style&index=0&id=0ee7f1a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee7f1a8",
  null
  
)

export default component.exports